import React from 'react';
import { Logo } from './Logo';
import { LinkedinIcon, TwitterIcon, InstagramIcon, FacebookIcon } from 'lucide-react';
import { useLanguage } from '../LanguageContext';
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="bg-navy pt-20 pb-10 border-t border-white/10" data-id="element-106">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-107">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-16" data-id="element-108">
          {/* Brand Column */}
          <div className="lg:col-span-2" data-id="element-109">
            <Logo className="h-10 mb-6" light data-id="element-110" />
            <p className="text-slate-400 mb-8 max-w-sm leading-relaxed" data-id="element-111">
              {t('footer_desc')}
            </p>
            <div className="flex gap-4" data-id="element-112">
              <a href="#linkedin" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-slate-400 hover:bg-electric hover:text-white transition-all" data-id="element-113">
                <LinkedinIcon className="w-5 h-5" data-id="element-114" />
              </a>
              <a href="#twitter" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-slate-400 hover:bg-electric hover:text-white transition-all" data-id="element-115">
                <TwitterIcon className="w-5 h-5" data-id="element-116" />
              </a>
              <a href="#instagram" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-slate-400 hover:bg-electric hover:text-white transition-all" data-id="element-117">
                <InstagramIcon className="w-5 h-5" data-id="element-118" />
              </a>
              <a href="#facebook" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-slate-400 hover:bg-electric hover:text-white transition-all" data-id="element-119">
                <FacebookIcon className="w-5 h-5" data-id="element-120" />
              </a>
            </div>
          </div>

          {/* Services Column */}
          <div data-id="element-121">
            <h4 className="text-white font-bold mb-6" data-id="element-122">{t('footer_col_1')}</h4>
            <ul className="space-y-4" data-id="element-123">
              <li data-id="element-124">
                <a href="#service" className="text-slate-400 hover:text-electric-light transition-colors" data-id="element-125">
                  {t('service_1_title')}
                </a>
              </li>
              <li data-id="element-126">
                <a href="#service" className="text-slate-400 hover:text-electric-light transition-colors" data-id="element-127">
                  {t('service_2_title')}
                </a>
              </li>
              <li data-id="element-128">
                <a href="#service" className="text-slate-400 hover:text-electric-light transition-colors" data-id="element-129">
                  {t('service_3_title')}
                </a>
              </li>
              <li data-id="element-130">
                <a href="#service" className="text-slate-400 hover:text-electric-light transition-colors" data-id="element-131">
                  {t('service_4_title')}
                </a>
              </li>
              <li data-id="element-132">
                <a href="#service" className="text-slate-400 hover:text-electric-light transition-colors" data-id="element-133">
                  {t('service_5_title')}
                </a>
              </li>
            </ul>
          </div>

          {/* Company Column */}
          <div data-id="element-134">
            <h4 className="text-white font-bold mb-6" data-id="element-135">{t('footer_col_2')}</h4>
            <ul className="space-y-4" data-id="element-136">
              <li data-id="element-137">
                <a href="#about" className="text-slate-400 hover:text-electric-light transition-colors" data-id="element-138">
                  {t('footer_link_about')}
                </a>
              </li>
              <li data-id="element-139">
                <a href="#team" className="text-slate-400 hover:text-electric-light transition-colors" data-id="element-140">
                  {t('footer_link_team')}
                </a>
              </li>
              <li data-id="element-141">
                <a href="#careers" className="text-slate-400 hover:text-electric-light transition-colors" data-id="element-142">
                  {t('footer_link_careers')}
                </a>
              </li>
              <li data-id="element-143">
                <a href="#case-studies" className="text-slate-400 hover:text-electric-light transition-colors" data-id="element-144">
                  {t('nav_case_studies')}
                </a>
              </li>
              <li data-id="element-145">
                <a href="#contact" className="text-slate-400 hover:text-electric-light transition-colors" data-id="element-146">
                  {t('nav_contact')}
                </a>
              </li>
            </ul>
          </div>

          {/* Resources Column */}
          <div data-id="element-147">
            <h4 className="text-white font-bold mb-6" data-id="element-148">{t('footer_col_3')}</h4>
            <ul className="space-y-4" data-id="element-149">
              <li data-id="element-150">
                <a href="#blog" className="text-slate-400 hover:text-electric-light transition-colors" data-id="element-151">
                  {t('footer_link_blog')}
                </a>
              </li>
              <li data-id="element-152">
                <a href="#whitepapers" className="text-slate-400 hover:text-electric-light transition-colors" data-id="element-153">
                  {t('footer_link_whitepapers')}
                </a>
              </li>
              <li data-id="element-154">
                <a href="#webinars" className="text-slate-400 hover:text-electric-light transition-colors" data-id="element-155">
                  {t('footer_link_webinars')}
                </a>
              </li>
              <li data-id="element-156">
                <a href="#faq" className="text-slate-400 hover:text-electric-light transition-colors" data-id="element-157">
                  {t('footer_link_faq')}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-158">
          <div className="text-slate-500 text-sm" data-id="element-159">{t('footer_copy')}</div>
          <div className="flex gap-6 text-sm" data-id="element-160">
            <a href="#privacy" className="text-slate-500 hover:text-white transition-colors" data-id="element-161">
              {t('footer_privacy')}
            </a>
            <a href="#terms" className="text-slate-500 hover:text-white transition-colors" data-id="element-162">
              {t('footer_terms')}
            </a>
            <a href="#cookies" className="text-slate-500 hover:text-white transition-colors" data-id="element-163">
              {t('footer_cookies')}
            </a>
          </div>
        </div>
      </div>
    </footer>;
}